// src/utils/emailService.js
import emailjs from "@emailjs/browser";

const PUBLIC_KEY = import.meta.env.VITE_EMAILJS_PUBLIC_KEY;
const SERVICE_ID = import.meta.env.VITE_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = import.meta.env.VITE_EMAILJS_TEMPLATE_ID;

if (PUBLIC_KEY) {
  emailjs.init(PUBLIC_KEY);
  console.log("✅ EmailJS initialized");
} else {
  console.error("❌ Missing VITE_EMAILJS_PUBLIC_KEY in .env");
}

/**
 * Send email via EmailJS
 * @param {Object} params - Template parameters
 * Example:
 * {
 *   form_type: "application" | "contact",
 *   fullName, email, phone, course, experience, motivation,
 *   agreeTerms, newsletter, college, year, branch,
 *   from_name, from_email, subject, message,
 *   timestamp
 * }
 */
export const sendEmail = async (params) => {
  if (!SERVICE_ID || !TEMPLATE_ID) {
    console.error("❌ Missing VITE_EMAILJS_SERVICE_ID or VITE_EMAILJS_TEMPLATE_ID");
    throw new Error("EmailJS not configured");
  }

  try {
    const res = await emailjs.send(SERVICE_ID, TEMPLATE_ID, params);
    console.log("📧 Email sent:", res.status, res.text);
    return res;
  } catch (err) {
    console.error("⚠️ EmailJS send error:", err);
    throw err;
  }
};
